export default __webpack_public_path__ + "static/media/HFS00513_WEDDING_1053.5f78945e.jpg";